/**
 * Return a new array with duplicate items removed by `id`, keeping the first
 * occurrence and preserving order.
 *
 * Needed for infinite-scroll lists: offset pagination accumulates pages, and
 * when the underlying data shifts between page fetches the same record can
 * appear in more than one page — producing duplicate React keys
 * ("Encountered two children with the same key"). Deduping by id before render
 * guarantees stable, unique keys regardless of pagination overlap.
 */
export function dedupeById<T extends { id: string | number }>(items: T[]): T[] {
  const seen = new Set<T['id']>();
  const result: T[] = [];
  for (const item of items) {
    if (seen.has(item.id)) continue;
    seen.add(item.id);
    result.push(item);
  }
  return result;
}
